import axios from "axios";
import config from "../config";
import { getToken } from "../utils/tokenUtils";

const apiurl = config.API_URL;

export const getProjectTypes = async () => {
  try {
    const response = await axios.get(`${apiurl}/api/v1/project-types`);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const getProjectLocations = async (cityquery) => {
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/work-locations?city=${cityquery}`
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const getProjectLanguages = async () => {
  try {
    const response = await axios.get(`${apiurl}/api/v1/work-languages`);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const getProjectGenres = async () => {
  try {
    const response = await axios.get(`${apiurl}/api/v1/projects/genre-list`);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const createProject = async (payload) => {
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/projects`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const getUserProjects = async (page, profileId, perpage = 6) => {
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/projects?user_id=${profileId}&page=${page}&per_page=${perpage}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );

    return response.data;

  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const getProjectDetailsById = async (projectId) => {
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/projects/${projectId}`, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
    //console.log("Nitish", response.data);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const updateProject = async (projectId, payload) => {
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/projects/${projectId}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const deleteProject = async (projectId) => {
  try {
    const response = await axios.delete(
      `${apiurl}/api/v1/user/projects/${projectId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const reportProject = async (projectId, reason) => {
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/projects/${projectId}/report`,
      { reason },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const getProjectFilterList = async () => {
  try {
    const response = await axios.get(`${apiurl}/api/v1/projects/filter-list`, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });

    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const getFilteredProjects = async (query) => {

  try {
    const response = await axios.get(
      `${apiurl}/api/v1/projects?${query}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  }
  catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const getProjectTeam = async (projectId) => {
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/user/projects/${projectId}/team`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const searchUsers = async (query) => {
  try {
    const response = await axios.get(`${apiurl}/api/v1/user/global-search`, {
      params: {
        query,
        type: 'people',
      },
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Search failed:", error);
    return Promise.reject(error?.response?.data || error.message);
  }
};

export const addTeamMember = async (projectId, payload) => {
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/projects/${projectId}/team`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error adding team member:", error);
    return Promise.reject(error.response.data);
  }
};

export const removeTeamMember = async (projectId, role_id) => {
  try {
    const response = await axios.delete(
      `${apiurl}/api/v1/user/projects/${projectId}/team`,
      {
        data: { role_id },
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const editTeamMember = async (projectId, payload) => {
  try {
    const response = await axios.put(
      `${apiurl}/api/v1/user/projects/${projectId}/team`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const arrangeTeamOrder = async (projectId, payload) => {
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/projects/${projectId}/team/order`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const getTeamPublicView = async (projectId) => {
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/projects/${projectId}/team/non-creator-view`
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const expressInterest = async (projectId, payload) => {
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/projects/${projectId}/express-interest`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    console.log("response expressInterest", response.data);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
}

export const writeProjectReview = async (projectId, payload) => {
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/projects/${projectId}/reviews`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const getProjectReviews = async (projectId, page, star, sortby) => {
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/projects/${projectId}/reviews?page=${page}&star=${star}&sort_by=${sortby}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const updateProjectReview = async (projectId, reviewId, payload) => {
  try {
    const response = await axios.put(
      `${apiurl}/api/v1/user/projects/${projectId}/reviews/${reviewId}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const deleteProjectReview = async (projectId, reviewId) => {
  try {
    const response = await axios.delete(
      `${apiurl}/api/v1/user/projects/${projectId}/reviews/${reviewId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};


export const getProjects = async (query) => {
  console.log("API - getProjects called with query:", query);
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/projects${query}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  }
  catch (error) {
    return Promise.reject(error.response.data);
  }
};